import { render, staticRenderFns } from "./supply-user-pass.vue?vue&type=template&id=05b3d122&scoped=true&"
import script from "./supply-user-pass.vue?vue&type=script&lang=js&"
export * from "./supply-user-pass.vue?vue&type=script&lang=js&"
import style0 from "./supply-user-pass.vue?vue&type=style&index=0&id=05b3d122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3d122",
  null
  
)

export default component.exports